import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Navigations with a #hash scroll to that element (e.g. /#quote → the quote form)
      setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) target.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      window.scrollTo(0, 0); // Scroll to the top whenever pathname changes
    }
  }, [pathname, hash]);

  return props.children;
};

export default ScrollToTop;
